import { render } from "./VerificationPopover.vue?vue&type=template&id=3c54bf94&scoped=true&ts=true"
import script from "./VerificationPopover.vue?vue&type=script&lang=ts"
export * from "./VerificationPopover.vue?vue&type=script&lang=ts"

import "./VerificationPopover.vue?vue&type=style&index=0&id=3c54bf94&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c54bf94"]])

export default __exports__